import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";

export function GameCardSkeleton() {
  return (
    <div
      className={cn(
        "relative group flex flex-col overflow-hidden rounded-xl bg-card-surface border border-card-border shadow-xl shadow-primary/5",
        "transition-all duration-300"
      )}
    >
      <div className="relative h-48 w-full bg-muted/70 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent" />
        <Skeleton className="absolute top-4 right-4 h-6 w-20 rounded-full bg-white/20" />
        <Skeleton className="absolute bottom-4 left-4 right-4 h-6 rounded-md bg-white/20" />
      </div>

      <div className="flex flex-col flex-1 p-5 gap-4">
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-3">
            <Skeleton className="w-9 h-9 rounded-full" />
            <Skeleton className="h-4 w-32" />
          </div>
          <div className="flex items-center gap-3">
            <Skeleton className="w-9 h-9 rounded-full" />
            <Skeleton className="h-4 w-40" />
          </div>
          <div className="flex items-center gap-3">
            <Skeleton className="w-9 h-9 rounded-full" />
            <Skeleton className="h-4 w-48" />
          </div>
        </div>

        <div className="flex items-center justify-between gap-4 mt-2">
          <div className="flex flex-col gap-2 flex-1">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="h-2.5 w-32 rounded-full" />
          </div>
          <Skeleton className="h-10 w-28 rounded-xl" />
        </div>
      </div>
    </div>
  );
}
